import _ from "lodash";

// Get all keys that point to a nested objects
export const objectsKeys = <
  A extends Record<string | number | symbol, unknown>
>(
  o: A
): string[] => Object.keys(o).filter((k) => _.isObject(o[k]));
